var _style, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 450",
    style: {
      enableBackground: "new 0 0 600 450"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#872166;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gt_skrill",
    viewBox: "-415.1 -415.1 830.1 830.1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-276.7-415.1h553.4c92.2,0,138.4,46.1,138.4,138.4v553.4c0,92.2-46.1,138.4-138.4,138.4h-553.4 c-92.2,0-138.4-46.1-138.4-138.4v-553.4C-415.1-368.9-368.9-415.1-276.7-415.1L-276.7-415.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.5-90.5l54.8-9.8v210.5h-54.8V-90.5z M274.6-90.5v200.6h54.9v-210.4L274.6-90.5z M116.6,110.1h54.8V-43.8 h-54.9L116.6,110.1z M-246-22c-7-0.5-23-1.5-23-15.9c0-17.4,23.1-17.4,31.7-17.4c15.2,0,35,4.5,49,8.7c0,0,7.9,2.8,14.5,5.6 l0.6,0.1v-47.7l-0.8-0.2c-16.6-5.8-35.9-11.4-71.8-11.4c-61.8,0-83.7,36-83.7,66.8c0,17.8,7.7,59.6,78.4,64.5c6,0.3,22,1.3,22,16.3 c0,12.3-13,19.6-35,19.6c-21.1-0.2-41.9-4.3-61.5-12v49.2c21.1,5.6,45.1,8.4,73.1,8.4c60.4,0,87.5-34.1,87.5-67.9 C-164.9,6.3-195.1-18.5-246-22L-246-22z M85.6-46C34.9-44.4,9.2-21.6,9.2,23.6v86.6h55.3V39.6c0-27.1,3.5-38.7,35.7-39.7v-45.1 C94.7-46.3,85.6-46,85.6-46z M-63.2-43.9c-7.4,19.5-18,37.6-31.3,53.6v-109.9L-151-89.1v199.2h56.6V48.5 c16.4,24.6,24.5,61.6,24.5,61.6h67.8c-6.7-27.9-36-79.3-36-79.3C-11.9-2.5-0.2-38.1,1.6-44L-63.2-43.9L-63.2-43.9z M143.8-58.6 c14.9,0,27-12.1,27-27s-12.1-27-27-27s-27,12.1-27,27l0,0C116.9-70.7,128.9-58.6,143.8-58.6L143.8-58.6z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gt_skrill",
    width: 830.1,
    height: 830.1,
    x: -415.1,
    y: -415.1,
    transform: "matrix(0.3782 0 0 0.3782 300 225)",
    style: {
      overflow: "visible"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrill);
export default __webpack_public_path__ + "static/media/skrill.16c20cc6446f5e130c750307b0f42f61.svg";
export { ForwardRef as ReactComponent };